import React, { FC } from 'react';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { IContentLayoutProps } from 'types/app';
import { useContent } from 'hooks';
import { IPostRenderProps } from 'features/posting';

import { getYouTubeId } from '../helpers';
import { EmbedYouTube } from '../widgets';
import { Embed } from '../layouts';

interface IPropsEnhanced extends IContentLayoutProps, IPostRenderProps, WithStyles<typeof styles> {}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: `${theme.spacing(1)}px auto 0`,
    },
  });

const YouTube: FC<IPropsEnhanced> = ({ classes, ...props }) => {
  const content = useContent();
  const videoId = getYouTubeId(content);

  return (
    <Embed {...props}>
      <div className={classes.root}>
        <EmbedYouTube id={videoId} />
      </div>
    </Embed>
  );
};

export default withStyles(styles)(YouTube);
